var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "constructionstage" },
    [
      _c(
        "div",
        {
          ref: "mainstage",
          staticClass: "con_stage__main",
          class: { con_stage__animation: _vm.animationRunning },
          on: {
            animationend: _vm.stopAnimation,
            mousedown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "left", 37, $event.key, [
                  "Left",
                  "ArrowLeft",
                ])
              )
                return null
              if ("button" in $event && $event.button !== 0) return null
              return _vm.handleMouseDown.apply(null, arguments)
            },
            mouseup: _vm.handleMouseUp,
            mousemove: _vm.handleMouseMove,
            mouseleave: _vm.handleMouseLeave,
            touchstart: _vm.handleTouchStart,
            touchend: _vm.handleTouchEnd,
            touchmove: _vm.handleTouchMove,
            touchcancel: _vm.handleTouchEnd,
            click: _vm.debugMousePosition,
          },
        },
        [
          _vm.configuration.image_bg
            ? _c("global-responsive-image", {
                staticClass: "con_stage__img con_stage__img--bg",
                attrs: { responsiveImage: _vm.configuration.image_bg },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.configuration.image_fg
            ? _c("global-responsive-image", {
                staticClass: "con_stage__img con_stage__img--fg",
                style: _vm.sliderImageStyle,
                attrs: { responsiveImage: _vm.configuration.image_fg },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showSlider
            ? _c(
                "div",
                {
                  staticClass: "con_stage__handle",
                  style: _vm.sliderHandleStyle,
                },
                [
                  _c("div", {
                    staticClass: "con_stage__handle-left",
                    class: {
                      "con_stage__handle-left--visible": _vm.showLeftHandle,
                    },
                    on: { click: _vm.handleLeftHandlerClick },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "con_stage__handle-right",
                    class: {
                      "con_stage__handle-right--visible": _vm.showRightHandle,
                    },
                    on: { click: _vm.handleRightHandlerClick },
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.configuration.types, function (type) {
            return [
              _c(
                "div",
                {
                  staticClass: "con_stage__marker",
                  class: {
                    "con_stage__marker--light": type.theme_box === "light",
                    "con_stage__marker--dark": type.theme_box === "dark",
                    "con_stage__marker--active":
                      _vm.selectedType === type ||
                      (_vm.hoverType === type &&
                        (!_vm.isMobile || _vm.animationRunning)),
                  },
                  style: _vm.getStyleForMarker(type.position),
                  on: {
                    click: function ($event) {
                      return _vm.toggleSelectedType(type, $event)
                    },
                    mouseenter: function ($event) {
                      return _vm.setHoverType(type)
                    },
                    mouseleave: function ($event) {
                      return _vm.setHoverType(null)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "con_stage__marker-content",
                      class: {
                        "con_stage__marker-content--light":
                          type.theme_name === "light",
                        "con_stage__marker-content--dark":
                          type.theme_name === "dark",
                      },
                    },
                    [_vm._v(_vm._s(type.name))]
                  ),
                  _vm._v(" "),
                  _c("GlobalResponsiveImage", {
                    staticClass: "con_stage__marker-image",
                    attrs: { responsiveImage: type.image, lazy: false },
                  }),
                ],
                1
              ),
            ]
          }),
          _vm._v(" "),
          _vm._m(0),
        ],
        2
      ),
      _vm._v(" "),
      _vm.selectedType && _vm.isMobile
        ? [
            _vm._l(_vm.selectedType.bauteile, function (bauteil, bauteilIndex) {
              return [
                _c(
                  "global-accordion",
                  {
                    attrs: {
                      "accordion-type": "3",
                      open: _vm.selectedBauteil === bauteil,
                      "use-content-stage": true,
                    },
                    on: {
                      toggleAccordion: function ($event) {
                        return _vm.toggleSelectedBauteil(bauteil)
                      },
                    },
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(bauteil.name) },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("constructionstage-bauteil", {
                      attrs: {
                        slot: "body",
                        bauteil: bauteil,
                        activeBreakpoint: _vm.activeBreakpoint,
                      },
                      slot: "body",
                    }),
                  ],
                  2
                ),
              ]
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedType && !_vm.isMobile
        ? [
            _c(
              "div",
              { staticClass: "con_stage__side" },
              [
                _c(
                  "div",
                  { staticClass: "global-filter-list global-filter-list--vue" },
                  [
                    _c(
                      "ul",
                      { staticClass: "filter--list filter__body" },
                      _vm._l(_vm.selectedType.bauteile, function (bauteil) {
                        return _c("li", { key: bauteil.name }, [
                          _c("button", {
                            staticClass: "filter filter--secondary",
                            class: { active: _vm.selectedBauteil === bauteil },
                            domProps: {
                              innerHTML: _vm._s(bauteil.navigation_name),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.setSelectedBauteil(bauteil)
                              },
                            },
                          }),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.selectedBauteil
                  ? _c("constructionstage-bauteil", {
                      attrs: {
                        bauteil: _vm.selectedBauteil,
                        activeBreakpoint: _vm.activeBreakpoint,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "con_stage__cursor" }, [
      _c("div", { staticClass: "con_stage__click" }),
      _vm._v(" "),
      _c("div", { staticClass: "con_stage__pointer" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }